module.exports = __webpack_public_path__ + "static/media/trash-icon.80366dbc.svg";